/**
 * Register Form Schema
 * Zod validation schema for registration form.
 * Uses shared atoms (CrevasseEmailSchema, LegalNameSchema, PasswordSchema)
 * piped after a UX-tone empty check.
 */

import { z } from 'zod';
import { CrevasseEmailSchema, LegalNameSchema, PasswordSchema } from '@aegislab/shared';

export const registerFormSchema = z
  .object({
    email: z.string().min(1, '이메일을 입력해주세요').pipe(CrevasseEmailSchema),
    username: z.string().min(1, '이름을 입력해주세요').pipe(LegalNameSchema),
    password: z.string().min(1, '비밀번호를 입력해주세요').pipe(PasswordSchema),
    passwordConfirm: z.string().min(1, '비밀번호 확인을 입력해주세요'),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: '비밀번호가 일치하지 않습니다',
    path: ['passwordConfirm'],
  });

export type RegisterFormData = z.infer<typeof registerFormSchema>;

export const registerFormDefaults: RegisterFormData = {
  email: '',
  username: '',
  password: '',
  passwordConfirm: '',
};
